jQuery(function ($) {
  // Vous êtes
  $(".wpcf7-form input[name=radio-vous]").change(function () {
    if (this.value == "Une entreprise") {
      $(".col-adresse").show();
    } else {
      $(".col-adresse").hide();
    }
  });



});
